import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';
import logoXCoin from '../assets/logo_plateado.png';
import background from '../assets/backhome.png';
// Icons
import { FaGift, FaRocket, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';

const ReferralLandingView = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const refWallet = searchParams.get('ref');

    const [email, setEmail] = useState('');
    const [referrerEmail, setReferrerEmail] = useState(''); // New State
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (refWallet) {
            // Fetch Referrer Info
            const fetchReferrer = async () => {
                try {
                    const obtenerInfo = httpsCallable(functions, 'obtenerInfoReferidor');
                    const res = await obtenerInfo({ walletAddress: refWallet });
                    if (res.data.success && res.data.email) {
                        setReferrerEmail(res.data.email);
                    }
                } catch (e) {
                    console.warn("Could not fetch referrer info", e);
                }
            };
            fetchReferrer();
        }
    }, [refWallet]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!refWallet) {
            setError("Enlace de invitación inválido (falta código).");
            setLoading(false);
            return;
        }

        try {
            const registrarLead = httpsCallable(functions, 'registrarLeadReferido');
            const res = await registrarLead({ email, referrerAddress: refWallet });

            if (res.data.success) {
                setSuccess(true);
                // Auto redirect after 3s?
                setTimeout(() => {
                    // Redirect to Register, passing 'modal' if we want the modal look, or normal.
                    // We want them to Register with *this* email.
                    navigate(`/register?email=${encodeURIComponent(email)}`);
                }, 3000);
            } else {
                setError(res.data.message || 'Error al registrar.');
            }
        } catch (err) {
            console.error(err);
            setError(err.message || 'Error de conexión.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100svh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start', // Start from top for scroll consistency
            backgroundImage: `url(${background})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            padding: '40px 20px 80px', // Extra bottom padding for safe area
            overflowY: 'auto',
            boxSizing: 'border-box'
        }}>
            <div className="card referral-landing-card" style={{
                maxWidth: '500px',
                width: '100%',
                padding: window.innerWidth < 480 ? '30px 20px' : '40px',
                backgroundColor: 'rgba(15, 23, 42, 0.95)',
                borderRadius: '20px',
                border: '1px solid #334',
                boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
                textAlign: 'center',
                color: 'white',
                margin: 'auto 0' // Vertically center IF there is space, else natural flow
            }}>

                {/* LOGO */}
                <img src={logoXCoin} alt="XCoin" style={{ height: window.innerWidth < 480 ? '45px' : '60px', marginBottom: '20px' }} />

                {/* TRACEABILITY: REFERRER INFO */}
                {refWallet && (
                    <div style={{ marginBottom: '20px', fontSize: '0.85rem', color: '#888', background: 'rgba(255,255,255,0.05)', padding: '5px 10px', borderRadius: '15px', display: 'inline-block' }}>
                        Invitado por: <span style={{ fontFamily: 'monospace', color: '#00d2ff', fontWeight: 'bold' }}>
                            {referrerEmail || `${refWallet.substring(0, 6)}...${refWallet.substring(refWallet.length - 4)}`}
                        </span>
                    </div>
                )}

                {!success ? (
                    <>
                        <h1 style={{ fontSize: window.innerWidth < 480 ? '1.5rem' : '2rem', marginBottom: '10px', background: 'linear-gradient(45deg, #ffd700, #ffaa00)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                            ¡Te han invitado a XCoin!
                        </h1>
                        <p style={{ fontSize: window.innerWidth < 480 ? '0.95rem' : '1.1rem', color: '#ccc', marginBottom: '25px' }}>
                            Has recibido una invitación exclusiva para unirte a la Preventa del Primer Crypto Renta Fija de Chile.
                        </p>

                        {/* BENEFIT CARDS */}
                        <div style={{ display: 'flex', gap: '12px', marginBottom: '25px' }}>
                            <div style={{ flex: 1, background: 'rgba(255, 215, 0, 0.1)', padding: '12px', borderRadius: '10px', border: '1px solid rgba(255, 215, 0, 0.2)' }}>
                                <FaGift size={20} style={{ color: '#ffd700', marginBottom: '5px' }} />
                                <h4 style={{ margin: '5px 0', color: '#ffd700', fontSize: '0.9rem' }}>1% Extra</h4>
                                <small style={{ color: '#aaa', fontSize: '0.75rem' }}>En Bonos XCO</small>
                            </div>
                            <div style={{ flex: 1, background: 'rgba(0, 210, 255, 0.1)', padding: '12px', borderRadius: '10px', border: '1px solid rgba(0, 210, 255, 0.2)' }}>
                                <FaRocket size={20} style={{ color: '#00d2ff', marginBottom: '5px' }} />
                                <h4 style={{ margin: '5px 0', color: '#00d2ff', fontSize: '0.9rem' }}>Renta Fija</h4>
                                <small style={{ color: '#aaa', fontSize: '0.75rem' }}>Hasta 3.5%</small>
                            </div>
                        </div>

                        <p style={{ marginBottom: '15px', fontWeight: 'bold', fontSize: '0.95rem' }}>
                            Ingresa tu correo para activar tus beneficios:
                        </p>

                        <form onSubmit={handleSubmit}>
                            <div style={{ marginBottom: '15px' }}>
                                <input
                                    type="email"
                                    placeholder="tu@correo.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        borderRadius: '10px',
                                        border: '1px solid #445',
                                        background: '#0f172a',
                                        color: 'white',
                                        fontSize: '1rem',
                                        textAlign: 'center',
                                        boxSizing: 'border-box'
                                    }}
                                />
                            </div>

                            {error && (
                                <div style={{ color: '#ff4d4d', marginBottom: '15px', background: 'rgba(255, 77, 77, 0.1)', padding: '10px', borderRadius: '5px', fontSize: '0.85rem' }}>
                                    <FaExclamationTriangle style={{ marginRight: '5px' }} /> {error}
                                </div>
                            )}

                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    width: '100%',
                                    padding: '14px 10px',
                                    borderRadius: '10px',
                                    border: 'none',
                                    background: 'linear-gradient(90deg, #00d2ff 0%, #3a7bd5 100%)',
                                    color: 'white',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    opacity: loading ? 0.7 : 1,
                                    transition: 'background 0.3s',
                                    whiteSpace: 'normal',
                                    lineHeight: '1.2'
                                }}
                            >
                                {loading ? 'Activando...' : 'ACTIVAR BONOS Y CONTINUAR'}
                            </button>
                        </form>

                        <p style={{ marginTop: '20px', fontSize: '0.8rem', color: '#666' }}>
                            * Al continuar serás redirigido al registro. Debes usar este mismo correo.
                        </p>
                    </>
                ) : (
                    <div style={{ padding: '20px 0' }}>
                        <FaCheckCircle size={60} style={{ color: '#4caf50', marginBottom: '20px' }} />
                        <h2 style={{ color: 'white', marginBottom: '15px' }}>¡Beneficios Activados!</h2>
                        <p style={{ color: '#ccc', marginBottom: '20px' }}>
                            Tu correo ha sido vinculado exitosamente a la invitación.
                        </p>
                        <p style={{ color: '#00d2ff', fontWeight: 'bold' }}>
                            Redirigiendo al registro...
                        </p>
                        <div className="loader" style={{ margin: '20px auto' }}></div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default ReferralLandingView;
